import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { useEffect, useState } from "react";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { useParams } from "react-router-dom";
import { Agendamento } from "../../../services/Agendamento";
import { Pagamento } from "../../../services/Pagamento";
import { toast } from "react-toastify";
import { IFaturaDTO } from "../../../types/pagamento";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";

export const useDocDownload = () => {
  const [agendamento, setAgendamento] = useState<IAgendamentoDTO>(
    {} as IAgendamentoDTO
  );
  const [fatura, setFatura] = useState<IFaturaDTO>({} as IFaturaDTO);
  const params = useParams();

  useEffect(() => {
    Agendamento.getById({ uuid: params?.id })
      .then(({ data }) => {
        setAgendamento(data);
      })
      .finally(() => {});

    Pagamento.consultarFatura({ uuidAgendamento: params?.id })
      .then(({ data }) => {
        const value = data?.content?.find(
          (f) => f.status === StatusPagamentoEnum.pending || f.status === StatusPagamentoEnum.paid
        );

        setFatura(value);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      );
  }, [params]);

  useEffect(() => {
    if (agendamento?.uuid) return;

    setTimeout(() => {
      handleDownload();
    }, 1000);
  }, [agendamento]);

  function handleDownload() {
    const input = document.getElementById("container");

    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        pdf.internal.pageSize.getWidth(),
        pdf.internal.pageSize.getHeight()
      );
      pdf.save("recibo.pdf");
    });
    // .finally(() => {
    //   window.close();
    // });
  }

  return { agendamento, fatura };
};
